import { BaseState } from "./base-state.svelte";
import type { NavigationInfo } from "./models/navigation-info.svelte";
import { browser } from "$app/environment";

export class AppState extends BaseState<AppState> {
	darkMode = $state(false);
	prevLink = $state<NavigationInfo | null>(null);
	nextLink = $state<NavigationInfo | null>(null);
	menuVisible = $state(false);
	searchVisible = $state(false);
	searchQuery = $state("");

	links = $state<{
		click4survey: { href: string; label: string };
		plansAndPrices: { href: string; label: string };
		support: { href: string; label: string };
	}>({
		click4survey: { href: "https://www.click4survey.cz", label: "Click4Survey" },
		plansAndPrices: { href: "https://www.click4survey.cz/ceny", label: "Plány a ceny" },
		support: { href: "https://www.click4survey.cz/kontakty", label: "Podpora" },
	});

	constructor() {
		super();

		if (browser) {
			this.darkMode =
				window?.localStorage?.getItem("theme") === "dark" ||
				window?.matchMedia("(prefers-color-scheme: dark)").matches;
		}
	}

	toggleDarkMode = () => {
		this.darkMode = !this.darkMode;
		if (browser) {
			window?.localStorage?.setItem("theme", this.darkMode ? "dark" : "light");
		}
	};
}

export const appState = BaseState.getInstance(AppState);
